import { IconButton, styled } from "@mui/material";
import { IStyledChatCloseButtonProps } from "./types";

const StyledCloseButton = styled(IconButton)<IStyledChatCloseButtonProps>(({theme})=>({
    "& .MuiSvgIcon-root":{
        color: (theme as any).palette.neutral.lightest
    }
}))

export {StyledCloseButton}